import autenticacao from './autenticacao'
import dashboard from './dashboard'

var Middleware = {
  autenticacao,
  dashboard,
}

export default Middleware
